import firebase from 'firebase/compat/app'

import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import 'firebase/compat/auth'
import 'firebase/compat/functions'
import fbSetttings from './firebase'

const firebaseApp = firebase.initializeApp(fbSetttings)

export const auth = firebase.auth()
export const fun = firebase.functions()
export const db = firebaseApp.firestore()
export const storage = firebaseApp.storage()
export const googleProvider = new firebase.auth.GoogleAuthProvider()
export const fbProvider = new firebase.auth.FacebookAuthProvider()
export const twitterProvider = new firebase.auth.TwitterAuthProvider()
export const providers = {
  'Google': googleProvider,
  'Facebook': fbProvider,
  'Twitter': twitterProvider
}

// Stripe
export const stripeKey = 'pk_live_ta8c4Wj9n0VEanSCMf5VzuU300VEdp1bWW'
export const stripe = window.Stripe(stripeKey, { locale: 'es' })
export const elements = stripe.elements({locale: 'es'})
export const stripePlan = 'plan_FDzGjBnoWBORG5'
export const recurringPayment = '19,99€/año'
export const analytics = ['UA-3749328-65']

export const facebook = {
  hun: {
    appId: '179912574339842',
    clientKey: 'fba94fcd7394af57a6d738ae656e3219'
  },
  cz: {
    appId: '364038435588590',
    clientKey: 'a7cc6a4c3bea5f124d43c4c878a89dba'
  }
}

export const brightcove = {
  hun: {
    accountId: '6302605131001',
    iosUrl: 'https://apps.apple.com/us/app/amc-mikro/id1541859533',
    iosImage: '/ios.png',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.amcnetworks.microhun',
    androidImage: '/android.png',
    facebook: 'https://www.facebook.com/amcmikrohu',
    instagram: 'https://www.instagram.com/amcmikrohu',
    terms: 'https://us-central1-microcanales-cne-df069.cloudfunctions.net/doc/terms',
    privacy: 'https://us-central1-microcanales-cne-df069.cloudfunctions.net/doc/privacy',
    about: '/mi-az-amc-mikro'
  },
  cz: {
    accountId: '6302598266001',
    iosUrl: 'https://apps.apple.com/us/app/amc-mikro/id1541859423',
    iosImage: '/ios-cz.png',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.amcnetworks.microcze',
    androidImage: '/android-cz.png',
    facebook: 'https://www.facebook.com/amcmikroczech',
    instagram: 'https://www.instagram.com/amcmikroczech',
    terms: 'https://us-central1-amc-mikro-cz.cloudfunctions.net/doc/terms-cz',
    privacy: 'https://us-central1-amc-mikro-cz.cloudfunctions.net/doc/privacy-cz',
    about: '/co-je-amc-mikro'
  }
}

